// Common specifications used across products
const commonSpecs = [
    { key: 'Power Supply', value: '100-240V AC' },
    { key: 'Operating temperature', value: '0 – 35°C' },
    { key: 'Ambient humidity', value: '0 – 95% RH' },
    { key: 'Range', value: 'up to 50 m outdoors / up to 40 m indoors' }
];

const controlPanelFeatures = ['WiFi/Zigbee Enabled', 'Capacitive Touch', 'Customizable Icons', 'Scene Control'];
const insetModuleFeatures = ['WiFi/Zigbee Enabled', 'Easy Installation', 'Voice Control', 'App Integration'];

// Product images using Unsplash
const productImages = {
    panel1: '/images/products/Senses4.png',
    panel2: '/images/products/Senses4Plus.png',
    panel3: '/images/products/Senses8.png',
    panel4: '/images/products/Senses8Plus.png',
    panel5: '/images/products/Senses10.png',
    panel6: '/images/products/Senses10Plus.png',
    module1: '/images/products/NodeInsertModule.png',
};

export const productList = [
    {
        id: 1,
        name: 'Senses 4',
        image: productImages.panel1,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '2M' },
            { key: 'Controls', value: '4 Switches' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '86mm x 86mm x 35mm' },
        ]
    },
    {
        id: 2,
        name: 'Senses 4 Plus',
        image: productImages.panel2,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '4M' },
            { key: 'Controls', value: '4 Switches + 1 Multi-Socket' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '86mm x 86mm x 35mm' },
        ]
    },
    {
        id: 3,
        name: 'Senses 8',
        image: productImages.panel3,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '4M' },
            { key: 'Controls', value: '8 Switches' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '86mm x 86mm x 35mm' },
        ]
    },
    {
        id: 4,
        name: 'Senses 8 Plus',
        image: productImages.panel4,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '6/8M' },
            { key: 'Controls', value: '8 Switches + 1 Multi-Socket' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '86mm x 86mm x 35mm' },
        ]
    },
    {
        id: 5,
        name: 'Senses 10',
        image: productImages.panel5,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '6/8M' },
            { key: 'Controls', value: '10 Switches' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '86mm x 86mm x 35mm' },
        ]
    },
    {
        id: 6,
        name: 'Senses 10 Plus',
        image: productImages.panel6,
        category: 'Control Panels',
        description: 'Premium glass touch panel with capacitive technology',
        features: controlPanelFeatures,
        specifications: [
            { key: 'Gang', value: '10/12M' },
            { key: 'Controls', value: '10 Switches + 1 Multi-Socket' },
            { key: 'Type', value: 'On/Off or Scene Switch' },
            { key: 'Rated load current', value: '10A per switch' },
            ...commonSpecs,
            { key: 'Dimensions', value: '120mm x 86mm x 35mm' },
        ]
    },
    {
        id: 7,
        name: 'Node 3R',
        image: productImages.module1,
        category: 'Control Modules',
        description: 'Compact modules for retrofit installations',
        features: insetModuleFeatures,
        specifications: [
            { key: 'Controls', value: '1/2/3 On/Off Switch' },
            { key: 'Load Type', value: 'Resistive/Inductive/Capacitive' },
            { key: 'Type', value: 'Relay Module' },
            ...commonSpecs,
            { key: 'Dimensions', value: '45mm x 45mm x 20mm' },
        ]
    },
    {
        id: 8,
        name: 'Node DIM',
        image: productImages.module1,
        category: 'Control Modules',
        description: 'Compact modules for retrofit installations',
        features: insetModuleFeatures,
        specifications: [
            { key: 'Controls', value: 'Light Dimmer' },
            { key: 'Load Type', value: 'Resistive/Capacitive' },
            { key: 'Type', value: 'Relay Module' },
            ...commonSpecs,
            { key: 'Dimensions', value: '45mm x 45mm x 20mm' },
        ]
    },
    {
        id: 9,
        name: 'Node FAN',
        image: productImages.module1,
        category: 'Control Modules',
        description: 'Compact modules for retrofit installations',
        features: insetModuleFeatures,
        specifications: [
            { key: 'Controls', value: 'Fan Dimmer' },
            { key: 'Load Type', value: 'Inductive' },
            { key: 'Type', value: 'Relay Module' },
            ...commonSpecs,
            { key: 'Dimensions', value: '45mm x 45mm x 20mm' },
        ]
    },
    {
        id: 10,
        name: 'Node CUR',
        image: productImages.module1,
        category: 'Control Modules',
        description: 'Compact modules for retrofit installations',
        features: insetModuleFeatures,
        specifications: [
            { key: 'Controls', value: 'Curtain Dimmer' },
            { key: 'Load Type', value: 'Inductive' },
            { key: 'Type', value: 'Relay Module' },
            ...commonSpecs,
            { key: 'Dimensions', value: '45mm x 45mm x 20mm' },
        ]
    }
]